<template>
    <div>
        <field-group
            v-for="(item, index) in list"
            :rules="innerRules"
            :key="index"
            :model="item"
            class="room-item"
        >
            <Row :gutter="5">
                <Col span="4">
                    <!-- 配套选择 -->
                    <FormItem class="room-field" prop="parentId">
                        <Select
                            v-model="item.parentId"
                            style="display: block"
                            transfer
                            @on-change="onFacilityChange($event, item)"
                        >
                            <Option
                                v-for="(v, index) in facilityList"
                                :value="v.id"
                                :key="index"
                                >{{ v.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <!-- 数量选择 -->
                    <FormItem class="room-field" prop="num">
                        <Select
                            v-model="item.num"
                            transfer
                            style="display: block"
                            @on-change="onNumChange($event, item)"
                        >
                            <Option
                                v-for="v in item.maxNum"
                                :value="v"
                                :key="v"
                                >{{ v }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <!-- 品牌参数选择 -->
                    <FormItem class="room-field" prop="facilityId">
                        <Select
                            v-model="item.facilityId"
                            transfer
                            style="display: block"
                            @on-change="onBrandChange($event, item)"
                        >
                            <Option
                                v-for="(v, index) in item.brandList"
                                :value="v.id"
                                :key="index"
                                >{{ v.title }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <!-- 总价 -->
                    <FormItem class="room-field" prop="price">
                        <input-number
                            v-model="item.price"
                            readonly
                            style="padding-right: 30px"
                        />
                    </FormItem>
                    <span
                        v-if="finalEditable"
                        class="room-cut"
                        @click="cut(index)"
                        >-</span
                    >
                </Col>
                <!-- 不显示，仅为收集数据 -->
                <Col span="0" v-show="false">
                    <FormItem prop="id" label="配套id">
                        <Input v-model="item.id"></Input>
                    </FormItem>
                </Col>
            </Row>
        </field-group>
        <div v-if="finalEditable" style="line-height: 30px">
            <div class="room-add" @click="add">
                <span class="room-add-plus">+</span>添加配置
            </div>
        </div>
    </div>
</template>
<script>
import { Field } from 'ivux'
import { assetsFacilityList } from '@/api/assets'

function createItem() {
    return {
        id: '',
        paraentId: '', // 配套设备id
        num: '', // 个数
        facilityId: '', // 品牌参数id
        price: '', // 总价
        maxNum: 0, // 最大配套数
        brandList: [], // 品牌参数列表
    }
}

// 房间配置
export default {
    name: 'RoomConfig',
    mixins: [Field],
    props: {
        value: {
            type: Array,
            default: () => [createItem()],
        },
        populateType: {
            type: String,
            default: 'chain',
        },
    },
    data() {
        return {
            // state
            list: [],
            // data
            facilityList: [],
        }
    },
    watch: {
        value: {
            handler(val) {
                this.setData(val)
            },
            immediate: true,
        },
        facilityList() {
            this.setData(this.list)
        },
    },
    computed: {
        innerRules() {
            return {
                parentId: [{ required: true, message: '配置必填' }],
                num: [{ required: true, message: '数量必填' }],
                facilityId: [{ required: true, message: '品牌必填' }],
            }
        },
    },
    created() {
        assetsFacilityList({
            pageSize: 99999,
            pageNo: 1,
        }).then((res) => {
            var list = res.data.page.list
            // 数据标准格式化
            list.forEach((v) => {
                v.text = v.title
                v.children.forEach((p) => (p.price /= 100))
                v.brandList = v.children
            })

            this.facilityList = list
        })
    },
    methods: {
        onFacilityChange(parentId, item) {
            var fancility = this.facilityList.find((v) => v.id == parentId)

            // 联动设置最大数量以及品牌参数列表
            item.maxNum = fancility.num
            item.brandList = fancility.brandList
        },

        onNumChange(n, item) {
            this.calcAmount(item)
        },

        onBrandChange(id, item) {
            var brand = item.brandList.find((v) => v.id == id)

            item.brandPrice = brand.price

            this.calcAmount(item)
        },

        // 计算配套设施总价
        calcAmount(item) {
            item.price = parseFloat(
                (item.num || 0) * (item.brandPrice || 0).toFixed(2)
            )
        },

        add() {
            this.list.push(createItem())
        },

        cut(i) {
            this.list.splice(i, 1)
        },

        setData(list = []) {
            list.forEach((v) => {
                var option = this.facilityList.find((p) => p.id === v.parentId)
                if (option) {
                    Object.assign(v, {
                        maxNum: option.num,
                        brandList: option.brandList,
                        brandPrice: v.price,
                    })
                }
            })
            this.list = list
        },
    },
}
</script>
<style lang="less" scoped>
.room {
    &-item {
        position: relative;
        margin-bottom: 24px;
    }

    &-field {
        flex-basis: 20px;
        margin-bottom: 0;
    }

    &-text {
        margin-right: 10px;
    }

    &-cut {
        position: absolute;
        top: 0;
        right: 0;
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
